// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__2hvsv","content":"LayoutSettings_content__1zAXh"};